/* ========================== */
/* ========= import ========= */
/* ========================== */
/* ====== React ====== */
import React, { useEffect, useState } from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';
import { ButtonSearchNonSubmit } from "02CommonUiParts/ButtonParts/ButtonBase";
import { CFArrayConcatFount, CFArrayFount } from "03CommonApiParts/CommonFunction";
import { inputCheckMaster, patternCheckMaster } from "03CommonApiParts/CodeDefinition";
import { useRef } from "react";

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
const SdivInputGroup = styled.div` //インプットのグループ
    margin:0 5px;
`;
const SdivInputTileLabel = styled.div`//入力項目のタイトル
    white-space: nowrap;
    display: flex;
    align-items: center;
`;
const Slabel = styled.label` //ラベル表示
    margin:0 0 0 6px;
    /* height:32px; */
    display:flex;
    align-items: center;
`;
const Sinput = styled.input` //入力欄
    border: 1px solid rgb(192, 192, 192);
    width:430px;
    height:28px;
    padding:0 5px;
    margin-top: 2px;
    border-radius:3px;
    background-color:${props => props.readOnly ? 'transparent' :props.isDirty? assets().color.lightYellow : 'white'};
    &:disabled{
        color:black;
        opacity:1;
        background-color:${props => props.readOnly ? 'red' : assets().color.disabled};
        border:${assets().color.disabled};
    }
    &:focus{
        outline: solid 1.5px ${assets().color.focusOutline};
    };
`;
const Sul = styled.ul`
    display: block;
    font: inherit;
    max-height: 300px;
    width: 428px;
    background-color: white;
    border: 1px solid #b5b5b5;
    overflow: scroll;
    white-space: nowrap;
    margin: 0;
    padding: 0;
`;
const SliRange = styled.li`//選択肢（オプション）
    position: relative;
    display: block;
    padding: 3px 4px;
    /* border-bottom: 1px solid #b5b5b5; */
    font-size: ${assets().size.baseText};
    /* font-weight: bold; */
    line-height: 20px;
    cursor: default;
    :hover{
        background-color: ${assets().color.whiteHover};
    }
`;
const SdivListWrapper = styled.div`
    /* margin: 0 calc(50% - 50vw);
    width: 40vw; */
    position: absolute;
    z-index: 20;
    margin-top: 27px;
    padding-bottom: 60px;
`
/* =============================== */  
/* = table用inputList検索ボタン付き = */  
/* =============================== */  
export const InputVariableListField = (props) => {
    const { id, name, title, placeholder, register, width, disabled, rightLabel , value, readOnly,list, range, onClickButton, setValue,fields, trigger,isDirty} = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    const [listOpen, setListOpen] = useState(false);
    const listRef = useRef(null);

    const click = (event) => {
        const empNmb = ('00000' + event.target.value).slice(-5);//0から始まるIDを取得した際に、数字で取得されるため,、00000を追加し結合後削除
        const data = CFArrayFount(range,'empNmb',`${empNmb}`);
        const empData = {
            ...fields,
            empNmb:(data.empNmb ? data.empNmb : '') + ' ' + (data.empFullName ? data.empFullName : '') + ' ' + (data.mailAdrs ? data.mailAdrs :''),
            dptCd:(data.dptCd ? data.dptCd : '') + ' ' + (data.dptAbrName ? data.dptAbrName : '')
        };
        setValue(id, empData);
        setListOpen(false);
        trigger(name); // リストがクリックされたときにバリデーションをし直してエラーを消す
    };
    document.addEventListener('click', (e) => {
        if(!listOpen) return;
        if(e.target.name){
            if(listOpen !== e.target.name){
                setListOpen(false);
            }
        }
    })
    const onClickSearchButton = (e) =>{
        e.preventDefault();
        onClickButton(name);
        setListOpen(id);
    }

    const onBlurInput = (e) =>{
        listOpen && setListOpen(false)
    }
    return (
            <>
            <div style={{display:'flex',zIndex:100}} ref={listRef}>
            <SdivInputGroup className='InputVariable'>
                <div style={{display:'flex'}}>
                    {title?<SdivInputTileLabel className='baseText' style={{fontSize:assets().size.baseText}}>{title}</SdivInputTileLabel>:<></>}
                    <Sinput
                        isDirty={isDirty}
                        {...register(`${name}`,
                        {
                            value:value,
                            onBlur:(e) => onBlurInput(e),
                            required: !disabled ? CFArrayFount(inputCheckMaster.list,'value','required').label:'',
                            pattern: {
                                        value: CFArrayFount(patternCheckMaster.list,'value','space').detailItemValidationTypeCode,
                                        message:CFArrayFount(patternCheckMaster.list,'value','space').label
                                    },
                            validate:{
                                invalidData: v => {
                                    if(!v)return;
                                    let inputValue = v.split(' ')[0];
                                    let inputName = v.split(' ')[1];
                                    let inputName2 = v.split(' ')[2];
                                    let inputMail = v.split(' ')[3];
                                    if(!inputMail || !inputName2 || !inputName || !inputValue){
                                        return CFArrayFount(inputCheckMaster.list, 'value', 'invalidInput').label;
                                    }
                                }
                            }
                        })} 
                        autoComplete='off'
                        maxLength={400}
                        disabled={disabled}
                        readOnly={readOnly}
                        style={{fontSize:assets().size.baseText,height:assets().size.inputHeight,width:width}}
                        placeholder={placeholder}
                        type='search'
                        className='inputText'
                        // onFocus={() => range.length > 0 && setListOpen(id)}//フォーカス時はリストを表示
                    />
                    {range.length > 0 && listOpen && 
                        <SdivListWrapper style={{top: listRef.current?.getBoundingClientRect().top}}>
                            <Sul id = {list}>
                            {range.map((item) => (
                                <SliRange
                                    key={item.empNmb}
                                    value={item.empNmb}
                                    className='baseText options'
                                    style={{fontSize:assets().size.baseText}}
                                    onClick={(event) => click(event)}//クリックに発起者情報入力処理を実行
                                >
                                    {item.empNmb + '　' + item.empFullName + '　' + item.mailAdrs}
                                </SliRange>
                            ))}
                            </Sul>
                        </SdivListWrapper>
                    }
                    <Slabel className='baseText'style={{fontSize:assets().size.baseText}}>{rightLabel}</Slabel>
                    <ButtonSearchNonSubmit onClick={(e)=>onClickSearchButton(e)} disabled={disabled}/>
                </div>
                {/* {errorMessage &&  <InputErrorMessage errorMessage={errorMessage}/>} */}
            </SdivInputGroup>
        </div>
        </>
    );
};

/* ======================================== */  
/* = leftTitleTable用inputList検索ボタン付き = */  
/* ======================================== */  
export const InputVariableListFieldLeft = (props) => {
    const { id, name, title, placeholder, register, width, disabled, rightLabel , value, readOnly,list, range, onClickButton, setValue, clearErrors, trigger, errorMessage,isDirty} = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    const [listOpen, setListOpen] = useState(false);
    const [ran, setRan] = useState([]);
    const [beforeValue,setBeforeValue] = useState('');
    useEffect(() => {
        setRan(range);
        range.length && clearErrors('payload.mnaEmpNmb');
    },[range, clearErrors]);

    useEffect(() =>{
        setBeforeValue(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    const click = (event) => {
        const empNmb = ('00000' + event.target.value).slice(-5);//0から始まるIDを取得した際に、数字で取得されるため,、00000を追加し結合後削除
        const data = CFArrayFount(ran,'empNmb',`${empNmb}`);
        const empData = (data.empNmb ? data.empNmb : '') + ' ' + (data.empFullName ? data.empFullName : '');
        setValue(id, empData);
        setListOpen(false);
        trigger(name); // リストがクリックされたときにバリデーションをし直してエラーを消す
    };
    document.addEventListener('click', (e) => {
        if(e.target.name){
            if(listOpen !== e.target.name){
                setListOpen(false);
            }
        }
    });
    const onClickSearchButton = async(e) =>{
        e.preventDefault();
        await onClickButton(name);
        setListOpen(id);
    }

    const onBlurInput = (e) =>{
        listOpen && setListOpen(false)
    }
    return (
        <div style={{display:'flex',zIndex:100}} key={id}>
            <SdivInputGroup className='InputVariable' style={{margin: '6px 0 0 0'}}>
                <div style={{display:'flex', position:'relative'}}>
                    {title?<SdivInputTileLabel className='baseText' style={{fontSize:assets().size.baseText}}>{title}</SdivInputTileLabel>:<></>}
                    <Sinput
                        isDirty={isDirty}
                        {...register(`${name}`,
                        {
                            value:value,
                            onBlur:(e) => {
                                trigger?.(name);
                                return onBlurInput(e);
                            },
                            pattern: {
                                        value: CFArrayFount(patternCheckMaster.list,'value','space').detailItemValidationTypeCode,
                                        message:CFArrayFount(patternCheckMaster.list,'value','space').label
                                    },
                            validate:{
                                invalidData: v => {
                                    if(!v || v === beforeValue) return;
                                    // let inputValue = v.split(' ')[0];
                                    // let inputName = v.split(' ')[1];
                                    // let inputName2 = v.split(' ')[2];
                                    if(!CFArrayConcatFount(ran, v)){
                                        return CFArrayFount(inputCheckMaster.list, 'value', 'invalidInput').label;
                                    }
                                }
                            }
                        })} 
                        id={id}
                        autoComplete='off'
                        maxLength={400}
                        disabled={disabled}
                        readOnly={readOnly}
                        style={{fontSize:assets().size.baseText,height:assets().size.inputHeight,width:width}}
                        placeholder={placeholder}
                        type='search'
                        className='inputText'
                        // onFocus={() => range.length > 0 && setListOpen(id)}//フォーカス時はリストを表示
                    />
                    {ran.length > 0 && listOpen && 
                        <SdivListWrapper>
                            <Sul id = {list}>
                            {ran.map((item) => (
                                <SliRange
                                    key={item.empNmb}
                                    value={item.empNmb}
                                    className='baseText options'
                                    style={{fontSize:assets().size.baseText}}
                                    onClick={(event) => click(event)}//クリックに発起者情報入力処理を実行
                                >
                                    {item.empNmb + '　' + item.empFullName}
                                </SliRange>
                            ))}
                            </Sul>
                        </SdivListWrapper>
                    }
                    <Slabel className='baseText'style={{fontSize:assets().size.baseText}}>{rightLabel}</Slabel>
                    <ButtonSearchNonSubmit onClick={(e)=>onClickSearchButton(e)} disabled={disabled}/>
                    {errorMessage &&  <div style={{marginTop: '6px'}}><InputErrorMessage errorMessage={errorMessage}/></div>}
                </div>
            </SdivInputGroup>
        </div>
    );
};